<!-- KYMW7000 表紙・特集掲載商品選定画面（CX） -->
<div class="contents-area">
  <!-- 検索条件 -->
  <div class="layout_balance">
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-text-with-catalog #txt_OrderCode [autofocus]="true" [required]="true" [tabindex]="0"
              [forcedEnabledMode]="'true'" [(ngModel)]="kymw7000Model.orderCode" width="100"
              (onChangedCatalogId)="kymw7000Model.catalogId = $event" 
              (ngModelChange)="eventOrderCode_CHANGEHandler()">
            </app-order-text-with-catalog>
          </div>
          
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-versatile-combo-box id="cmb_MediumType" [(ngModel)]="kymw7000Model.mediumType" [listSource]="kymw7000Model.MediumList"
              valueField="Code" labelField="Name" [disabled]="false" [required]="true" [tabindex]="0" [width]="250"
              [dspBothField]="true" [visible]="true" [blank]="true" [autofocus]="false" forcedEnabledMode="true"
              (ngModelChange)="eventMediumType_CHANGEHandler()">
            </app-versatile-combo-box>
          </div>
        </div>
        
        <div class="column-list">
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <app-catalog-text-with-order #catalogId [autofocus]="true" [required]="true" [tabindex]="0"
              [forcedEnabledMode]="'true'" [(ngModel)]="kymw7000Model.catalogId" width="100"
              (onChangedOrderCode)="kymw7000Model.orderCode = $event">
            </app-catalog-text-with-order>
          </div>
          
          <label class="list-input-title">特集</label>
          <div class="list-input-content">
            <app-versatile-combo-box id="cmb_FeatureType" [(ngModel)]="kymw7000Model.featureCode"
              [listSource]="kymw7000Model.FeatureList"valueField="Code" labelField="Name" 
              [disabled]="false" [required]="false" [tabindex]="0" [width]="250"[dspBothField]="true" 
              [visible]="true" [blank]="true" [autofocus]="false" forcedEnabledMode="true"
              (ngModelChange)="eventFeatureType_CHANGEHandler()">
            </app-versatile-combo-box>
          </div>
        </div>
      </div>
      <button id="btn_Display" #btn_Display class="btn-secondary" [disabled]="false"
        [tabindex]="0" (click)="eventDisplay_CLICKHandler()" forcedEnabledMode="true">表示</button>
    </div>
    <div class="column-list">
      <label class="list-input-title">備考</label>
      <app-text-area id="FeatureMemo" class="text-label-normal" [height]="150" [width]="700"
        [(ngModel)]="kymw7000Model.featureMemo" [disabled]="permission !== '2' || !featureMemoDisable"
        [displayCountField]="false" [maxChars]="500" [restrict]="'[ -￮]'" [fullOnly]="true">
      </app-text-area>
    </div>
  </div>

  <div class="element-column">
    <!-- 候補一覧 -->
      <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
        <wj-accordion-pane #wac_TargetList>
          <div>候補一覧</div>
          <div>
            <div class="element-column" style="max-width:1610px;">
              <button id="btn_Search" #btn_Search class="btn-secondary"
                [disabled]="true" [tabindex]="0" (click)="eventSeach_CLICKHandler()">商品検索</button>
              <wj-flex-grid #dtg_TargetList id="dtg_TargetList" [itemsSource]="kymw7000Model.TargetListInfo" [isReadOnly]="true"
                style="width: 1570px; height:160px;"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
                  <!-- 単体チェックボックス -->
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                        [(ngModel)]="cell.item.check" id="target_list_check_{{cell.row.index}}"
                        [disabled]="cell.item.checkFlag" (change)="eventTargetListChk_CLICKHandler()"/>
                    </div>
                  </ng-template>
                  <!-- 一括チェックボックス -->
                  <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                    <div class="all-target_list-checkbox">
                      <input type="checkbox" id="chk_AllTargetList" #chk_AllTargetList forcedEnabledMode="true" [tabindex]="0"
                        (change)="eventTagetListAll_CLICKHandler()" [(ngModel)]="kymw7000Model.targetListAll"
                        class="headear-checkbox all-target_list-checkbox" 
                        [disabled]="kymw7000Model.TargetListInfo.length === 0" />
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="100" [binding]="'pCode'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="300" [binding]="'guideGoodsName'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="200" [binding]="'guideStandardName'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="200" [binding]="'formatClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'大分類'" [minWidth]="5" [width]="180" [binding]="'formatLargeClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="180" [binding]="'formatMiddleClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'小分類'" [minWidth]="5" [width]="180" [binding]="'formatSmallClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'タグ'" [minWidth]="5" [width]="170" [binding]="'tagName'"></wj-flex-grid-column>
              </wj-flex-grid>
              <button id="btn_Selection" #btn_Selection class="btn-secondary" 
                [disabled]="true" [tabindex]="0" (click)="eventSelection_CLICKHandler()">選定</button>
            </div>    
          </div>
        </wj-accordion-pane>
      </wj-accordion>

      <!-- 選定商品一覧 -->
      <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
      <wj-accordion-pane>
        <div>選定商品一覧</div>
        <div>
          <div class="block-column">
            <div style="max-width:1610px; width:100%;">
              <h3>選定商品一覧</h3>
              <wj-flex-grid id="dtg_SelectionGoodsList" #dtg_SelectionGoodsList class="select-target-list" 
                  style="width:1570px; height:160px;" [itemsSource]="kymw7000Model.SelectionList" 
                  [isReadOnly]="true" overflow="auto" (scroll)="$event.stopPropagation()"
                  [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
                  <!-- 単体チェックボックス -->
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                        [(ngModel)]="cell.item.check" id="selection_goods_list_check_{{cell.row.index}}"
                        (change)="eventSelectionListChk_CLICKHandler()" [disabled]="permission !== '2'"/>
                    </div>
                  </ng-template>
                  <!-- 一括チェックボックス -->
                  <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                    <div class="all-selection_list-checkbox">
                      <input type="checkbox" id="chk_AllSelectionGoodsList" #chk_AllSelectionGoodsList forcedEnabledMode="true" [tabindex]="0"
                        (change)="eventSelectionListAll_CLICKHandler()" [(ngModel)]="kymw7000Model.selectionListAll"
                        class="headear-checkbox all-selection_list-checkbox" 
                        [disabled]="kymw7000Model.SelectionList.length === 0 || permission !== '2'"/>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="100" [binding]="'formatFeature'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [binding]="'formatClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="150" [binding]="'formatMiddleClass'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pCode'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="100" [binding]="'guideGoodsName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="100" [binding]="'guideStandardName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="100" [binding]="'pricePattern'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <!-- 共通コンポーネントでは文字色変更に対応できないため個々で実装 -->
                      <select id="cmb_price-list" labelField="CodeValue" [(ngModel)]="cell.item.pricePattern"
                        style="width: 100%; height: 25px;" [ngClass]="{'red-text': cell.item.isChangedPricePattern === '1'}" 
                        class="text-label-required" forcedEnabledMode="true" (change)="eventPricePettern_CHANGEHandler(SelectionListType.SelectionGoods, cell.item)" 
                        [tabindex]="0" [disabled]="permission !== '2'">
                        <ng-template ngFor let-item [ngForOf]="kymw7000Model.PricePetternList">
                          <option value="{{item.CodeValue}}">
                            {{item.CodeName}}
                          </option>
                        </ng-template>
                      </select>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input 
                        id="selectionThisTimeSupplyPrice" type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                        [(ngModel)]="cell.item.thisTimeSupplyPrice" [disabled]="permission !== '2'" [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="7"
                        [ngClass]="{'red-text': cell.item.isChangedSupplyPrice === '1'}"
                        (change)="eventThisTimeSupplyPrice_CHANGEHandler(SelectionListType.SelectionGoods, cell.item)" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="90" [binding]="'thisTimeCostPrice'" [align]="'right'">
                  <div>
                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" >
                      <input id="selectionThisTimeCostPrice"
                        type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                        [(ngModel)]="cell.item.thisTimeCostPrice" [disabled]="permission !== '2'"
                        [ngClass]="{'red-text': cell.item.isChangedCostPrice === '1'}"
                        (change)="eventThisTimeCostPrice_CHANGEHandler(SelectionListType.SelectionGoods, cell.item)"
                        [restrict]="'[.0-9]'" [halfOnly]="true" [maxlength]="10" plessInputTextSub>
                    </ng-template>
                  </div>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'計画数(予測)'" [minWidth]="5" [width]="100" [binding]="'predictPlanNum'" [align]="'right'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'計画数(修正)'" [minWidth]="5" [width]="100" [binding]="'planNum'" [align]="'right'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input 
                        id="selectionPlanNum" type="text" style="width: 100%; text-align: right;" [(ngModel)]="cell.item.planNum" 
                        [ngClass]="{'red-text': cell.item.isChangedPlanNum === '1'}" 
                        (change)="eventPlanNum_CHANGEHandler(SelectionListType.SelectionGoods, cell.item)" [disabled]="permission !== '2'"
                        [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="7" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'計画供給高'" [minWidth]="5" [width]="115" [binding]="'planSupplyBudget'" [align]="'right'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input 
                        id="selectionPlanSupplyBudget"
                        type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                        [(ngModel)]="cell.item.planSupplyBudget" [disabled]="permission !== '2'"
                        [ngClass]="{'red-text': cell.item.isChangedPlanSupplyBudget === '1'}"
                        (change)="eventPlanSupplyBudget_CHANGEHandler(SelectionListType.SelectionGoods, cell.item)"
                        [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="11" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="100" [binding]="'gpr'" [align]="'right'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'タグ'" [minWidth]="5" [width]="90" [binding]="'tagName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="77" [binding]="'remarks'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input id="selectionRemarks" type="text" style="width: 100%;" [disabled]="permission !== '2'" 
                        [(ngModel)]="cell.item.remarks" [restrict]="'[ -￮]'" [maxlength]="100" plessInputTextSub [fullOnly]="true">
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
              </wj-flex-grid>
              <div class="block-row">
                <div style="width: 765px;">
                <button id="btn_SelectionCannel" #btn_SelectionCannel class="btn-tartiary" 
                  [disabled]="true" [tabindex]="0" (click)="eventSelectionCannel_CLICKHandler()">選定解除</button>
                </div>
                <div class="block-row" style="column-gap: 1px;">
                  <label class="tottaling-label" style="width: 99px; height: 30px;">小計</label>
                  <!-- 仕入価 -->
                  <input type="text" style="width: 89px; height: 30px; text-align: right;" readonly
                    [ngModel]="kymw7000Model.selectionTotalCostPrice">
                  <!-- 計画数(予想) -->
                  <input type="text" style="width: 99px; height: 30px; text-align: right" readonly
                    [ngModel]="kymw7000Model.selectionTotalPredictPlanNum">
                  <!-- 計画数(修正) -->
                  <input type="text" style="width: 99px; height: 30px; text-align: right" readonly
                    [ngModel]="kymw7000Model.selectionTotalPlanNum">
                  <!-- 計画供給高 -->
                  <input type="text" style="width: 114px; height: 30px; text-align: right" readonly
                    [ngModel]="kymw7000Model.selectionTotalSupplyBudget">
                  <!-- GPR -->
                  <input type="text" style="width: 99px; height: 30px; text-align: right" readonly
                    [ngModel]="kymw7000Model.selectionTotalGpr">
                </div>
              </div>
            </div>
            <div style="max-width:1610px; width:100%;">
              <h3>商品部への選定依頼一覧</h3>
              <wj-flex-grid #dtg_SelectionRequestList style="width:1570px; height:160px;"
                [itemsSource]="kymw7000Model.SelectionRequestInfo" [isReadOnly]="true"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <!-- 単体チェックボックス -->
                    <div>
                      <input type="checkbox" [tabindex]="-1"(mouseup)="$event.stopPropagation()" 
                        [(ngModel)]="cell.item.check" id="selection_request_list_check_{{cell.row.index}}"
                        (change)="eventRequestListChk_CLICKHandler()" [disabled]="permission !== '2'"/>
                    </div>
                  </ng-template>
                  <!-- 一括チェックボックス -->
                  <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                    <div class="all-request_list-checkbox">
                      <input type="checkbox" id="chk_AllSelectionRequestList" #chk_AllSelectionRequestList forcedEnabledMode="true" [tabindex]="0"
                        (change)="eventRequestListAll_CLICKHandler()" [(ngModel)]="kymw7000Model.requestListAll"
                        class="headear-checkbox all-request_list-checkbox" 
                        [disabled]="kymw7000Model.SelectionRequestInfo.length === 0 || permission !== '2'"/>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="100" [binding]="'formatFeature'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" >
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <app-class-code-combo-box 
                        [required]="true" style="width: 100%;" [disabled]="permission !== '2'" 
                        [(ngModel)]="cell.item.classCode" (change)="eventClass_CHANGEHandler(cell.item, cell.row.index, $event)">
                      </app-class-code-combo-box>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="150">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <app-middle-class-code-combo-box 
                        style="width: 100%;" [disabled]="permission !== '2'" 
                        [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="false"
                        [classCode]="cell.item.classCode"
                        [(ngModel)]="cell.item.middleClassCode" 
                        (change)="eventEditHandler(); eventMiddleClass_CHANGEHandler(cell.item, cell.row.index, $event);">
                      </app-middle-class-code-combo-box>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input 
                        id="requestPcode" type="text" style="width: 100%;" [disabled]="permission !== '2'"
                        [(ngModel)]="cell.item.pCode" (change)="eventPcode_CHANGEHandler(cell)"
                        [restrict]="'[P0-9]'" [maxlength]="8" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="100" [binding]="'guideGoodsName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="100" [binding]="'guideStandardName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="100">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <app-versatile-combo-box id="cmb_PricePettern" [(ngModel)]="cell.item.pricePattern"
                      [listSource]="kymw7000Model.PricePetternList" valueField="CodeValue" labelField="CodeName" 
                      [tabindex]="0" style="width: 100%;" [visible]="true" [blank]="true" 
                      [autofocus]="false" (change)="eventPricePettern_CHANGEHandler(SelectionListType.SelectionRequest, cell.item)"
                      [disabled]="permission !== '2'">
                    </app-versatile-combo-box>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="90" [binding]="'thisTimeCostPrice'" [align]="'right'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'計画数'" [minWidth]="5" [width]="100" [align]="'right'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input id="reuestPlanNum" type="text" style="width: 100%; text-align: right;" [disabled]="permission !== '2'"
                        [(ngModel)]="cell.item.planNum" (change)="eventPlanNum_CHANGEHandler(SelectionListType.SelectionRequest, cell.item)"
                        [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="7" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'計画供給高'" [minWidth]="5" [width]="115" [align]="'right'">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <div>
                      <input id="reuestPrePlanNum" type="text" class="text-label-required" 
                        style="width: 100%; text-align: right;" [disabled]="permission !== '2'"
                        [(ngModel)]="cell.item.planSupplyBudget" (change)="eventPlanSupplyBudget_CHANGEHandler(SelectionListType.SelectionRequest, cell.item)"
                        [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="11" plessInputTextSub>
                    </div>
                  </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="100" [binding]="'gpr'" [format]="'n1'" [align]="'right'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'ステータス'" [minWidth]="5" [width]="100" [binding]="'requestStatusName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="167">
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <input id="requestRemarks" type="text" style="width: 100%;" 
                      [disabled]="permission !== '2'" [(ngModel)]="cell.item.remarks"
                      [restrict]="'[ -￮]'" [maxlength]="100" plessInputTextSub [fullOnly]="true">
                  </ng-template>
                </wj-flex-grid-column>
              </wj-flex-grid>
    
              <div class="element-column">
                <div class="block-row" style="width: 100%;">
                  <div style="width: 765px;">
                    <div class="layout_balance" style="width: 180px;">
                      <button id="btn_Delete" #btn_Delete class="btn-tartiary warning" style="width: 80px;" readonly
                      [disabled]="true"[tabindex]="0" (click)="eventDelete_CLICKHandler()">削除</button>
                      <button id="btn_Add" #btn_Add class="btn-secondary" style="width: 80px;" readonly
                      [disabled]="true"[tabindex]="0" (click)="eventAdd_CLICKHandler()">追加</button>
                    </div>
                  </div>
                  <div class="block-row" style="column-gap: 1px;">
                    <label class="tottaling-label" style="width: 99px; height: 30px;">小計</label>
                    <!-- 仕入価 -->
                    <input type="text" style="width: 89px; height: 30px; text-align: right" readonly
                    [ngModel]="kymw7000Model.requestTotalCostPrice">
                    <!-- 計画数 -->
                    <input type="text" style="width: 99px; height: 30px; text-align: right" readonly
                      [ngModel]="kymw7000Model.requestTotalPlanNum">
                    <!-- 計画供給高 -->
                    <input type="text" style="width: 114px; height: 30px; text-align: right" readonly
                      [ngModel]="kymw7000Model.requestTotalSupplyBudget">
                    <!-- GPR -->
                    <input type="text" style="width: 99px; height: 30px; text-align: right" readonly
                      [ngModel]="kymw7000Model.requestTotalGpr">
                  </div>
                </div>
            
                <div class="layout_balance">
                  <div class="block-row" style="width: 100%;">
                    <div style="width: 865px;">
                      <button id="btn_Download" #btn_Download class="btn-secondary"  
                        [disabled]="true" [tabindex]="0" (click)="eventDownload_CLICKHandler()">ダウンロード</button>
                      </div>
                    <div class="block-row" style="column-gap: 1px;">
                      <label class="tottaling-label" style="width: 89px; height: 30px;">本年計画</label>
                      <input type="text" style="width: 99px; height: 30px; text-align: right;" readonly
                        [ngModel]="kymw7000Model.requestThisYearPlanNum">
                      <input type="text" style="width: 114px; height: 30px; text-align: right;" readonly
                        [ngModel]="kymw7000Model.requestThisYearSupplyBudget">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </wj-accordion-pane>
      </wj-accordion>
  </div>

  <!-- 集計 -->
  <div>
    <h1>集計</h1>
    <div style="position:relative; max-width:1610px; width:100%;">
      <wj-flex-grid id="dtg_Totalling" #dtg_Totalling style="max-width:1610px; width:1367px; height:90px;" 
          [itemsSource]="kymw7000Model.TotallingInfo" [isReadOnly]="true" [allowSorting]="false" 
          [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
        <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="90" [binding]="'className'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'農産'" [minWidth]="5" [width]="90" [binding]="'farmProduct'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'水産'" [minWidth]="5" [width]="90" [binding]="'marineProduct'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'畜産'" [minWidth]="5" [width]="90" [binding]="'animalProduct'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'日配'" [minWidth]="5" [width]="90" [binding]="'dailyDelivery'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'菓子'" [minWidth]="5" [width]="90" [binding]="'sweets'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'食品'" [minWidth]="5" [width]="90" [binding]="'food'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'住関連'" [minWidth]="5" [width]="90" [binding]="'liveCategory'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'加工肉'" [minWidth]="5" [width]="90" [binding]="'processedMeat'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'パン生菓子'" [minWidth]="5" [width]="90" [binding]="'bread'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'酒'" [minWidth]="5" [width]="90" [binding]="'alcohol'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'米'" [minWidth]="5" [width]="90" [binding]="'rice'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'たまご・牛乳'" [minWidth]="5" [width]="90" [binding]="'eggAndMilk'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'冷食・アイス'" [minWidth]="5" [width]="90" [binding]="'freezedAndIce'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'惣菜'" [minWidth]="5" [width]="90" [binding]="'deliFoods'" [align]="'right'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<!-- gridのカラムと重なるためz-indexを指定（gridのカラムはz-index: 3） -->
<footer class="footer-buttons" style="z-index: 4">
  <!-- button 一時保存 -->
  <button id="btn_Save" #btn_Save class="btn-secondary"  
    [disabled]="true" [tabindex]="0" (click)="eventSave_CLICKHandler()">一時保存</button>
  <!-- button 確定 -->
  <button id="btn_Confirm" #btn_Confirm class="btn-primary"  
    [disabled]="true" [tabindex]="0" (click)="eventConfirm_CLICKHandler()">確定</button>
</footer>
